import { MarketplaceRetailerLink } from '../../types/marketplace-retailer-link'
import { getImage } from './graphql-to-featured-link'

export function graphqlToMarketplaceRetailerLink(
  item: any
): MarketplaceRetailerLink {
  const [imageUrl, imageType] = getImage(item)
  return {
    imageType,
    imageUrl: imageUrl || '',
    logoUrl:
      item?.retailerLogoSet?.coloured?.url ||
      item?.retailerLogoSet?.transparent?.url ||
      '',
    title: item.title,
    url: `/store/${item.sys.id}/${item.slug}`,
    shortDescription: item.shortDescription,
  }
}
